import { papa } from './papaparse';
import { IMPORT_COLUMN_SEPARATOR } from './sniffDelimiter';

/**
 * Serializes rows in the import API's own format, cells by position under
 * `header`, so a repaired file can be sent instead of the original. Rows
 * shorter than the header get empty cells.
 */
export function rewriteCsv(
  header: readonly string[],
  rows: readonly (readonly string[])[],
): string {
  const data = rows.map((cells) =>
    header.map((_, index) => cells[index] ?? ''),
  );

  return papa.unparse(
    { fields: header, data },
    { delimiter: IMPORT_COLUMN_SEPARATOR },
  );
}
